<div class="mt-2 ml-1 mr-1">
    <nc-notification-preferences></nc-notification-preferences>
</div>
